import styles from "./RecordIndicator.module.css";
import clsx from "clsx";

export interface RecordIndicatorProps {
  animated?: boolean;
  className?: string;
}

export const RecordIndicator: React.FC<RecordIndicatorProps> = ({ animated = true, className }) => {
  return (
      <div
        className={clsx({
          [styles.recordIndicator]: true,
          [styles.animated]: animated,
        }, className)}
      />
  );
};